(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('expandableText', {
            templateUrl: 'app/components/expandable-text/expandable-text.html',
            controller: expandableTextController,
            transclude: true,
            bindings: {
                textAlign: '@',
            }
        });

    /** @ngInject */
    function expandableTextController($rootScope, $scope, $sce, $translate, $translateSanitization, $element) {
        var $ctrl = this;
        var domElement = $element[0];

        $ctrl.$onInit = init;
        $ctrl.toggleExpanded = toggleExpanded;

        $ctrl.ellipsize = false;
        $ctrl.expanded = false;
        $ctrl.textAlign = $ctrl.textAlign || 'left'; // Default to left if not provided

        function init() {
            chechOverflow();
        }

        // Check if the element's scrollHeight exceeds the height of two lines
        function chechOverflow() {
            waitForElement('.status-message', domElement).then(function (element) {
                var lineHeight = parseFloat(window.getComputedStyle(element).lineHeight);
                var twoLinesHeight = Math.ceil(lineHeight * 2);
                $scope.$apply(function () {
                    $ctrl.ellipsize = element.offsetHeight > twoLinesHeight;
                });
            });
        }

        function toggleExpanded() {
            $ctrl.expanded = !$ctrl.expanded;
        }
    }
})();
